import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Badge,
  Input,
} from "reactstrap";
import AdminHeader from "components/Headers/AdminHeader";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import { DEFAULT_RECORDS_PER_PAGE } from "components/constant";
import { showAlert } from "components/CommonComponents/CommonFunctions";
import { urlDecodedId } from "components/CommonComponents/encodeDecodeFunction";

const DEFAULT_COURSE = {
  courseName: { value: "Energy Management Basics" },
  level: { value: "Beginner" },
  price: { value: 49.99 },
  courseType: { value: "Recorded" },
  TrainerName: { value: "Rahul Sharma, Gokul Patil" },
  courseStartDate: { value: "17 Jan 2026" },
  courseEndDate: { value: "30 Jan 2026" },
  totalEnrollment: { value: 159 },
};

const TRAINEE_LIST = [
  {
    id: "1",
    firstName: "Amit",
    lastName: "Kumar",
    email: "amit@test.com",
    mobile: "9867675647",
    gender: "Male",
    status: "Active",
  },
  {
    id: "2",
    firstName: "Ravi",
    lastName: "Sharma",
    email: "ravi@test.com",
    mobile: "9876543210",
    gender: "Male",
    status: "Active",
  },
  {
    id: "3",
    firstName: "Neha",
    lastName: "Singh",
    email: "neha@test.com",
    mobile: "9123456780",
    gender: "Female",
    status: "Inactive",
  },
  {
    id: "4",
    firstName: "Sonal",
    lastName: "Patel",
    email: "sonal@test.com",
    mobile: "9988776655",
    gender: "Female",
    status: "Active",
  },
  {
    id: "5",
    firstName: "Karan",
    lastName: "Gupta",
    email: "karan@test.com",
    mobile: "9012345678",
    gender: "Male",
    status: "Active",
  },
  {
    id: "6",
    firstName: "Pooja",
    lastName: "Verma",
    email: "pooja@test.com",
    mobile: "9122334455",
    gender: "Female",
    status: "Inactive",
  },
  {
    id: "7",
    firstName: "Vikas",
    lastName: "Reddy",
    email: "vikas@test.com",
    mobile: "9233445566",
    gender: "Male",
    status: "Active",
  },
  {
    id: "8",
    firstName: "Simran",
    lastName: "Kaur",
    email: "simran@test.com",
    mobile: "9344556677",
    gender: "Female",
    status: "Active",
  },
  {
    id: "9",
    firstName: "Rahul",
    lastName: "Jain",
    email: "rahul@test.com",
    mobile: "9455667788",
    gender: "Male",
    status: "Inactive",
  },
  {
    id: "10",
    firstName: "Anjali",
    lastName: "Shah",
    email: "anjali@test.com",
    mobile: "9566778899",
    gender: "Female",
    status: "Active",
  },
  {
    id: "11",
    firstName: "Rohit",
    lastName: "Mehta",
    email: "rohit@test.com",
    mobile: "9677889900",
    gender: "Male",
    status: "Active",
  },
  {
    id: "12",
    firstName: "Neetu",
    lastName: "Singh",
    email: "neetu@test.com",
    mobile: "9788990011",
    gender: "Female",
    status: "Inactive",
  },
];

const initialFields = {
  firstName: {
    value: "",
    error: "",
  },
  lastName: {
    value: "",
    error: "",
  },
  email: {
    value: "",
    error: "",
  },
  mobile: {
    value: "",
    error: "",
  },
};
function CoursePurchase() {
  const { id } = useParams();
  const decodedId = id ? urlDecodedId(id) : null;
  const navigate = useNavigate();

  const [course, setCourse] = useState(DEFAULT_COURSE);
  const [trainees, setTrainees] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [formData, setFormData] = useState(initialFields);
  const [pageNum, setPageNum] = useState(1);

  const DISCOUNT_PERCENT = 20;
  const totalAmount = trainees.length * course.price.value; // total for all trainees
  const discountAmount = (course.price.value * DISCOUNT_PERCENT) / 100; // 20% of course price only

  const isInterState = false; // later from backend / user profile
  const gstBaseAmount = totalAmount - discountAmount;

  const cgstAmount = !isInterState ? (gstBaseAmount * 9) / 100 : 0;
  const sgstAmount = !isInterState ? (gstBaseAmount * 9) / 100 : 0;
  const igstAmount = isInterState ? (gstBaseAmount * 18) / 100 : 0; //when inter state we have to apply
  const totalGstAmount = cgstAmount + sgstAmount + igstAmount;

  const finalPayableAmount = gstBaseAmount + totalGstAmount;
  
  useEffect(() => {
    if (decodedId) {
    }
  }, [decodedId]);

  useEffect(() => {
    setTrainees(TRAINEE_LIST);
  }, []);

  const columns = [
    {
      Header: "Sr No.",
      accessor: "id",
    },
    {
      Header: "First Name",
      accessor: "firstName",
      Cell: ({ row, value }) =>
        editIndex === row.original.id ? (
          <Input
            value={formData.firstName.value}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                firstName: { ...prev.firstName, value: e.target.value },
              }))
            }
            maxLength={50}
          />
        ) : (
          value
        ),
    },
    {
      Header: "Last Name",
      accessor: "lastName",
      Cell: ({ row, value }) =>
        editIndex === row.original.id ? (
          <Input
            value={formData.lastName.value}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                lastName: { ...prev.lastName, value: e.target.value },
              }))
            }
            maxLength={50}
          />
        ) : (
          value
        ),
    },
    {
      Header: "Email",
      accessor: "email",
      Cell: ({ row, value }) =>
        editIndex === row.original.id ? (
          <Input
            value={formData.email.value}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                email: { ...prev.email, value: e.target.value },
              }))
            }
            maxLength={100}
          />
        ) : (
          value
        ),
    },
    {
      Header: "Mobile",
      accessor: "mobile",
      Cell: ({ row, value }) =>
        editIndex === row.original.id ? (
          <Input
            value={formData.mobile.value}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                mobile: { ...prev.mobile, value: e.target.value },
              }))
            }
          />
        ) : (
          value
        ),
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) =>
        editIndex === row.original.id ? (
          <Button
            color="primary"
            className="btn-deep-blue py-2 px-3"
            onClick={handleSaveEdit}
          >
            Save
          </Button>
        ) : (
          <>
            <i
              className="fa fa-edit text-primary cursor mr-3"
              onClick={() => handleEdit(row.original)}
            />
            <i
              className="fa fa-trash text-danger cursor"
              onClick={() => handleRemove(row.original.id)}
            />
          </>
        ),
    },
  ];

  const handleEdit = (row) => {
    setEditIndex(row.id);
    setFormData({
      firstName: { value: row.firstName, error: "" },
      lastName: { value: row.lastName, error: "" },
      email: { value: row.email, error: "" },
      mobile: { value: row.mobile, error: "" },
    });
  };

  const handleSaveEdit = () => {
    setTrainees((prev) =>
      prev.map((t) =>
        t.id === editIndex
          ? {
              ...t,
              firstName: formData.firstName.value,
              lastName: formData.lastName.value,
              email: formData.email.value,
              mobile: formData.mobile.value,
            }
          : t,
      ),
    );
    setEditIndex(null);
    setFormData(initialFields);
  };

  const handleRemove = (id) => {
    const trainee = trainees.find((t) => t.id === id); // get the trainee object

    if (!trainee) return; // safety check

    showAlert({
      title: "Remove Trainee",
      message: (
        <>
          <p className="mb-1">Are you sure you want to remove this trainee?</p>
          <strong>
            {trainee.firstName} {trainee.lastName}
          </strong>
        </>
      ),
      type: "warning",
      confirmText: "Remove",
      cancelText: "Cancel",
      confirmStyle: "danger",
      onConfirm: () => {
        setTrainees((prev) => prev.filter((t) => t.id !== id));
      },
    });
  };

  //common fun to use to display data
  const CourseInfo = ({ iconClass, label, value, iconExtraClass = "" }) => {
    if (!value && value !== 0) return null; // skip empty values
    return (
      <div className="mb-2 d-flex align-items-center">
        <i className={`${iconClass} mr-2 text-muted ${iconExtraClass}`} />
        <span className="mr-1">{label} :</span>
        <strong>{value}</strong>
      </div>
    );
  };

  const handlePurchase = () => {
    //razorpay
  };
  return (
    <>
      <AdminHeader />
      <Container fluid className="mt--6">
        <Row>
          <Col>
            <Card className="mb-4">
              <CardHeader className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <i
                    className="fa fa-chevron-left mr-2 cursor"
                    onClick={() => navigate(-1)}
                  />
                  <h2 className="text-deep-blue mb-0">
                    {course.courseName.value}
                  </h2>
                </div>

                <div className="d-flex align-items-center">
                  <span className="purchase-price">₹{course.price.value}</span>
                  <span className="ml-1 text-muted">per Trainee</span>
                </div>
              </CardHeader>

              <CardBody>
                <Row>
                  <Col md="4">
                    <CourseInfo
                      iconClass="fa fa-user-tie"
                      label="Instructor"
                      value={course.TrainerName.value}
                    />
                  </Col>
                  <Col md="4">
                    <CourseInfo
                      iconClass="fa-solid fa-chart-simple"
                      label="Level"
                      value={course.level.value}
                    />
                  </Col>
                  <Col md="4">
                    <CourseInfo
                      iconClass="fa fa-video"
                      label="Course Type"
                      value={course.courseType.value}
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md="4">
                    <CourseInfo
                      iconClass="fa-regular fa-clock"
                      label="Duration"
                      value={`${course.courseStartDate.value} – ${course.courseEndDate.value}`}
                    />
                  </Col>
                  <Col md="4">
                    <CourseInfo
                      iconClass="fa fa-users"
                      label="Enrollment Count"
                      value={course.totalEnrollment.value}
                    />
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <Card>
              <CardHeader className="d-flex justify-content-between mb-n4">
                <h4>Trainees</h4>
                <div className="d-flex justify-content-end">
                  <Button
                    color="secondary"
                    onClick={() =>
                      navigate(
                        `/channel-partner/course/${id}/purchase/import-trainee`,
                      )
                    }
                  >
                    <i className="fa-solid fa-download pr-1"></i>
                    Import CSV
                  </Button>

                  <Button
                    color="primary"
                    className="btn-deep-blue"
                    onClick={() =>
                      navigate(`/channel-partner/course/${id}/purchase/add-trainee`)
                    }
                  >
                    + Trainee
                  </Button>
                </div>
              </CardHeader>

              <CardBody>
                <div className=" mb-3 mx-1">
                  {trainees.length ? (
                    <span className="total-records">
                      Total Records : {trainees.length}
                    </span>
                  ) : null}
                </div>

                <CommonTable
                  columns={columns}
                  data={trainees.slice(
                    (pageNum - 1) * DEFAULT_RECORDS_PER_PAGE,
                    pageNum * DEFAULT_RECORDS_PER_PAGE,
                  )}
                  defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
                  activePage={pageNum}
                  setPageNum={setPageNum}
                  totalPages={Math.ceil(
                    trainees.length / DEFAULT_RECORDS_PER_PAGE,
                  )}
                  showPaginationBottom={true}
                />
              </CardBody>

              <div className="border rounded p-3 bg-color mb-3">
                <div className="d-flex justify-content-between mb-2">
                  <span className="font-weight-bold">
                    Total Trainees : <strong>({trainees.length})</strong>
                  </span>
                  <span className="font-weight-bold">
                    Total Price : <strong>₹{totalAmount.toFixed(2)}</strong>
                  </span>
                </div>

                <div className="d-flex justify-content-end">
                  <span>
                    Discount : <strong>- ₹{discountAmount.toFixed(2)}</strong>
                  </span>
                </div>

                <div className="text-right text-muted mb-2">
                  <small className="d-block">
                    Admin applied discount : 20%
                  </small>
                </div>

                <div className="d-flex justify-content-end">
                  <span>
                    GST (18%) : <strong>₹{totalGstAmount.toFixed(2)}</strong>
                  </span>
                </div>

                <div className="text-right text-muted">
                  {!isInterState ? (
                    <>
                      <small className="d-block">
                        CGST (9%) : ₹{cgstAmount.toFixed(2)}
                      </small>
                      <small className="d-block">
                        SGST (9%) : ₹{sgstAmount.toFixed(2)}
                      </small>
                    </>
                  ) : (
                    <small className="d-block">
                      IGST (18%) : ₹{igstAmount.toFixed(2)}
                    </small>
                  )}
                </div>
                <hr className="my-2" />

                <div className="d-flex justify-content-end">
                  <span className="total mr-3">
                    Total Payable :{" "}
                    <strong> ₹{finalPayableAmount.toFixed(2)}</strong>
                  </span>
                </div>
              </div>
              <div className="text-right mb-4">
                <Button color="default" onClick={handlePurchase}>
                  Purchase Course
                </Button>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CoursePurchase;
